import React from "react";
import type { ErrorMessage } from "../types";

export interface ErrorDisplayProps {
  /** Accumulated error messages received via WebSocket. */
  errors: ErrorMessage[];
}

/**
 * Error and warning display for unresolved defects.
 *
 * Shows errors reported by the backend when fix loops are exhausted
 * (ERC, DRC, kicad-happy) or when other failures occur.
 */
const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ errors }) => {
  if (errors.length === 0) return null;

  return (
    <div className="error-display" role="alert">
      <h2>Errors &amp; Warnings</h2>
      <ul>
        {errors.map((err, i) => (
          <li key={i} className="error-item">
            <span className="error-type">{err.data?.error_type || "error"}</span>
            <span className="error-node">[{err.node || "pcb"}]</span>
            <span className="error-message">{err.message || (err.data as any)?.error || "Unknown error"}</span>
            {(err.data?.retry_count ?? 0) > 0 && (
              <span className="error-retries">
                ({err.data.retry_count} retries attempted)
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorDisplay;
